<div class="input-group vertical custom-input-group required" *ngIf="location">
  <section *ngIf="!user || !user.email || (user.email.indexOf('@') < 1)" class="form-group">
    <h6 class="group-header">Your email:</h6>
    <input type="text" [(ngModel)]="newEmail" placeholder="email" name="email"/>
  </section>
  <h6 class="group-header">I am not the correct point of contact for {{location.facility_name}}. Please use the following information for the point of contact:</h6>
  <textarea class="form-control custom-form-control" rows="7" [(ngModel)]="question" [ngModelOptions]="{standalone: true}"></textarea>
</div>
<button type="button" class="btn btn-primary float-right" (click)="send()" [disabled]="saving || !location">Submit</button>
